export const loginPage: string = "/login";
export const dashboardPage: string = "/dashboard";
export const usersPage: string = "/users";
export const userPage: string = "/user/:awsId";
export const operationsPage: string = "/operations";
export const giftsPage: string = "/gifts";
export const claimPage: string = "/claim";
export const crmPage: string = "/crm/whatsapp";
export const smsPage: string = "/crm/sms";